import { graphql, useStaticQuery } from 'gatsby';

export const useDirectusData = () => {
  const {
    directus: {
      blog_settings: settingsData,
      blog_categories: categoriesData,
      blog_top_articles: { top_articles: topArticlesData },
      blog_common: blogCommonData
    },
  } = useStaticQuery(graphql`
    query DirectusData {
      directus {
        blog_settings {
          page_title
          page_description
          blog_title
          blog_subtitle
          blog_button_label
          blog_hero_image {
            filename_disk
          }
          post_read_more_label
          blog_advert_image {
            filename_disk
          }
          blog_advert_link
          social_links
        }
        blog_categories {
          id
          name
          slug
        }
        blog_top_articles {
          top_articles {
            id
            blog_articles_id {
              name
              slug
              author {
                name
              }
              date_published
              image {
                filename_disk
              }
            }
          }
        }
        blog_common {
          common_footer_copy
        }
      }
    }
  `);
  return { settingsData, categoriesData, topArticlesData, blogCommonData };
};
